import React, { useState } from 'react';
import { Plus, Save, X, Package, DollarSign, Layers, Users, Check } from 'lucide-react';
export function AddProduct() {
  const [fulfillment, setFulfillment] = useState('NiishEngine Design Team');
  return <div className="max-w-4xl mx-auto space-y-8" data-id="element-836">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-837">
        <div className="flex items-center gap-4" data-id="element-838">
          <div className="p-3 bg-indigo-50 text-indigo-600 rounded-lg" data-id="element-839">
            <Package size={24} data-id="element-840" />
          </div>
          <div data-id="element-841">
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-842">
              Create Custom Service
            </h1>
            <p className="text-sm text-gray-500 font-medium" data-id="element-843">
              Define your own partner services and fulfillment rules.
            </p>
          </div>
        </div>
        <div className="flex gap-3" data-id="element-844">
          <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-845">
            <Save size={18} data-id="element-846" />
            Save Product
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-847">
        <div className="md:col-span-2 space-y-6" data-id="element-848">
          <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-sm space-y-6" data-id="element-849">
            <div className="space-y-2" data-id="element-850">
              <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-851">
                Product Name
              </label>
              <input type="text" placeholder="e.g. Monthly SEO Audit" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-852" />
            </div>

            <div className="space-y-2" data-id="element-853">
              <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-854">
                Description
              </label>
              <textarea placeholder="Describe the service value..." className="w-full h-32 p-4 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none resize-none" data-id="element-855" />
            </div>

            <div className="grid grid-cols-2 gap-6" data-id="element-856">
              <div className="space-y-2" data-id="element-857">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-858">
                  Retail Price
                </label>
                <div className="relative" data-id="element-859">
                  <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 font-bold" data-id="element-860">
                    $
                  </span>
                  <input type="number" placeholder="0.00" className="w-full pl-8 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-861" />
                </div>
              </div>
              <div className="space-y-2" data-id="element-862">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-863">
                  Billing Cycle
                </label>
                <select className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none appearance-none" data-id="element-864">
                  <option data-id="element-865">One-time</option>
                  <option data-id="element-866">Monthly Recurring</option>
                  <option data-id="element-867">Annual Recurring</option>
                </select>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-sm space-y-6" data-id="element-868">
            <h3 className="text-sm font-bold text-slate-900" data-id="element-869">
              Fulfillment Category
            </h3>
            <div className="grid grid-cols-2 gap-4" data-id="element-870">
              {[{
              id: 'NiishEngine Design Team',
              icon: Layers,
              desc: 'Automated fulfillment by NiishEngine experts.'
            }, {
              id: 'Partner Self-Fulfill',
              icon: Users,
              desc: 'You handle the delivery and support.'
            }].map(item => <button key={item.id} onClick={() => setFulfillment(item.id)} className={`p-4 rounded-lg border-2 text-left transition-all ${fulfillment === item.id ? 'border-indigo-600 bg-indigo-50/50' : 'border-gray-100 hover:border-gray-200'}`} data-id="element-871">
                  <div className="flex items-center justify-between mb-2" data-id="element-872">
                    <item.icon size={20} className={fulfillment === item.id ? 'text-indigo-600' : 'text-gray-400'} data-id="element-873" />
                    {fulfillment === item.id && <Check size={16} className="text-indigo-600" data-id="element-874" />}
                  </div>
                  <p className="text-sm font-bold text-slate-900" data-id="element-875">{item.id}</p>
                  <p className="text-[10px] text-gray-500 font-medium mt-1" data-id="element-876">
                    {item.desc}
                  </p>
                </button>)}
            </div>
          </div>
        </div>

        <div className="space-y-6" data-id="element-877">
          <div className="bg-slate-900 p-6 rounded-lg text-white space-y-4" data-id="element-878">
            <h3 className="text-sm font-bold" data-id="element-879">Profit Preview</h3>
            <div className="space-y-3" data-id="element-880">
              <div className="flex justify-between text-xs" data-id="element-881">
                <span className="text-slate-400" data-id="element-882">Retail Price</span>
                <span className="font-bold" data-id="element-883">$0.00</span>
              </div>
              <div className="flex justify-between text-xs" data-id="element-884">
                <span className="text-slate-400" data-id="element-885">NiishEngine Fee</span>
                <span className="font-bold text-red-400" data-id="element-886">-$0.00</span>
              </div>
              <div className="h-[1px] bg-slate-800" data-id="element-887"></div>
              <div className="flex justify-between text-sm" data-id="element-888">
                <span className="font-bold text-indigo-400" data-id="element-889">Your Profit</span>
                <span className="font-bold text-indigo-400" data-id="element-890">$0.00</span>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm space-y-4" data-id="element-891">
            <h3 className="text-sm font-bold text-slate-900" data-id="element-892">Visibility</h3>
            <div className="flex items-center justify-between" data-id="element-893">
              <span className="text-xs font-medium text-gray-500" data-id="element-894">
                Publish to Storefront
              </span>
              <div className="w-10 h-5 bg-indigo-600 rounded-full relative" data-id="element-895">
                <div className="absolute right-1 top-1 w-3 h-3 bg-white rounded-full" data-id="element-896"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}